import PrimeVue from "primevue/config";
import BadgeDirective from "primevue/badgedirective";
import Ripple from "primevue/ripple";
import StyleClass from "primevue/styleclass";
import Tooltip from "primevue/tooltip";
import FocusTrap from "primevue/focustrap";
import { defineNuxtPlugin } from "#app";
import ConfirmationService from "primevue/confirmationservice";
import ToastService from "primevue/toastservice";
import { useRuntimeConfig } from "nuxt/app";
export default defineNuxtPlugin((nuxtApp) => {
  const app = nuxtApp.vueApp;
  let primevueConfig = {};
  const runtimeConfig = useRuntimeConfig();
  const moduleConfig = runtimeConfig.public.primevue?.config;
  if (moduleConfig) {
    primevueConfig = moduleConfig;
  }
  app.use(PrimeVue, primevueConfig);
  app.directive("badge", BadgeDirective);
  app.directive("ripple", Ripple);
  app.directive("tooltip", Tooltip);
  app.directive("styleclass", StyleClass);
  app.directive("focustrap", FocusTrap);
  app.use(ConfirmationService);
  app.use(ToastService);
});
